import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faFacebookF,
  faFacebookSquare,
  faGooglePlusG,
  faGulp,
  faHotjar,
  faHtml5,
  faJs,
  faLinkedinIn,
  faMediumM,
  faNodeJs,
  faSass,
  faTrello,
  faTwitter,
  faYoutube,
  faInstagram,
  faInstagramSquare
} from '@fortawesome/free-brands-svg-icons';
import {
  faFlag as faFlagReg,
  faCircle as farCircle,
  faClock as farClock,
  faComment as farComment,
  faCopy as farCopy,
  faDizzy as farDizzy,
  faEdit as farEdit,
  faFile as farFile,
  faFileArchive as farFileArchive,
  faFileAudio as farFileAudio,
  faFileCode as farFileCode,
  faFileImage as farFileImage,
  faFilePdf as farFilePdf,
  faFileVideo as farFileVideo,
  faFloppyDisk as farFloppyDisk,
  faHeart as farHeart,
  faImage as farImage,
  faLaughBeam as farLaughBeam,
  faLightbulb as farLightbulb,
  faMessage as farMessage,
  faObjectUngroup as farObjectUngroup,
  faPaperPlane as farPaperPlane,
  faQuestionCircle as farQuestionCircle,
  faSmileBeam as farSmileBeam,
  faStar as farStar,
  faUser as farUser,
  faBuilding as farBuilding
} from '@fortawesome/free-regular-svg-icons';
import {
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  faAlignLeft,
  faAlignRight,
  faAngleDoubleUp,
  faAngleLeft,
  faAngleRight,
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightToBracket,
  faArrowUp,
  faArrowsAltV,
  faAt,
  faAtom,
  faBan,
  faBath,
  faBed,
  faBell,
  faBolt,
  faBook,
  faBookOpen,
  faBriefcase,
  faBug,
  faBuilding,
  faBuildingUser,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDay,
  faCamera,
  faCapsules,
  faCar,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCartPlus,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faChessRook,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleArrowLeft,
  faCircleArrowRight,
  faCircleNotch,
  faClock,
  faCloudDownloadAlt,
  faCode,
  faCodeBranch,
  faCog,
  faComments,
  faCopy,
  faCross,
  faCrown,
  faDollarSign,
  faDoorClosed,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faEraser,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileArchive,
  faFilePdf,
  faFilter,
  faFire,
  faFlag,
  faFlagCheckered,
  faFloppyDisk,
  faFolderPlus,
  faGift,
  faGlobe,
  faGlobeAmericas,
  faHeart,
  faHome,
  faHourglassHalf,
  faHouseUser,
  faIcons,
  faImage,
  faInfinity,
  faInfo,
  faInfoCircle,
  faKaaba,
  faLayerGroup,
  faLeftRight,
  faLink,
  faList,
  faListAlt,
  faListUl,
  faLocationArrow,
  faLock,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMap,
  faMapLocationDot,
  faMapMarkerAlt,
  faMessage,
  faMinus,
  faMobile,
  faMoneyBill,
  faMoon,
  faMusic,
  faNewspaper,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faPause,
  faPen,
  faPencilAlt,
  faPercentage,
  faPhone,
  faPlay,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPoll,
  faPowerOff,
  faPrint,
  faProjectDiagram,
  faPuzzlePiece,
  faQuestionCircle,
  faRedo,
  faReply,
  faRocket,
  faRotateLeft,
  faRotateRight,
  faRulerCombined,
  faSearch,
  faShapes,
  faShare,
  faShareAlt,
  faShieldHalved,
  faShoppingCart,
  faSignInAlt,
  faSlidersH,
  faSmileBeam,
  faSort,
  faSortAlphaDown,
  faSortAlphaUp,
  faSortAmountDown,
  faSortAmountUp,
  faSortNumericDown,
  faSortNumericUp,
  faSpinner,
  faStar,
  faStarHalfAlt,
  faStream,
  faSun,
  faSyncAlt,
  faTable,
  faTag,
  faTags,
  faTasks,
  faTh,
  faThumbsUp,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faTint,
  faTools,
  faTransgender,
  faTrash,
  faTrashAlt,
  faTrashCan,
  faUser,
  faUserAlt,
  faUserCircle,
  faUserFriends,
  faUserPlus,
  faUsers,
  faVideo,
  faWallet,
  faWrench,
  faXmark,
  faArrowsLeftRightToLine,
  faUpDownLeftRight,
  faCommentAlt,
  faInbox,
  faSync
} from '@fortawesome/free-solid-svg-icons';

library.add(
  //Own
  faSync,
  faInbox,
  faCommentAlt,
  faUpDownLeftRight,
  faInstagram,
  faInstagramSquare,
  farBuilding,
  faArrowsLeftRightToLine,
  faKaaba,
  faCar,
  faBath,
  faRulerCombined,
  faDoorClosed,
  faBed,
  faCircleArrowLeft,
  faCircleArrowRight,
  faArrowRightToBracket,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faEraser,
  faLeftRight,
  faRotateRight,
  faRotateLeft,
  farUser,
  faFlagCheckered,
  faFloppyDisk,
  faPowerOff,
  faMoneyBill,
  faHouseUser,
  faPlusCircle,
  faEyeSlash,
  faHourglassHalf,
  faAtom,
  faTransgender,
  faUserAlt,
  faWallet,
  // Solid
  faMessage,
  faRotateRight,
  faShieldHalved,
  faChartPie,
  faCopy,
  faXmark,
  faChessRook,
  faSearch,
  faHome,
  faBell,
  faPlay,
  faPause,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faChevronDown,
  faExchangeAlt,
  faAngleRight,
  faAngleLeft,
  faEllipsisH,
  faCrown,
  faListAlt,
  faCheck,
  faBan,
  faStream,
  faArrowsAltV,
  faSort,
  faSortAlphaDown,
  faSortAlphaUp,
  faSortNumericDown,
  faSortNumericUp,
  faSortAmountDown,
  faSortAmountUp,
  faCheckCircle,
  faUserCircle,
  faQuestionCircle,
  faLock,
  faCircle,
  faHeart,
  faShareAlt,
  faCaretRight,
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faPrint,
  faDollarSign,
  faLink,
  faPlus,
  faMinus,
  faUser,
  faPencilAlt,
  faCamera,
  faTimesCircle,
  faSignInAlt,
  faBook,
  faPuzzlePiece,
  faTrash,
  faAlignLeft,
  faAlignRight,
  faPlug,
  faTimes,
  faFilter,
  faExternalLinkAlt,
  faCartPlus,
  faShoppingCart,
  faStar,
  faStarHalfAlt,
  faArchive,
  faEnvelope,
  faClock,
  faStar,
  faReply,
  faLocationArrow,
  faCog,
  faPaperclip,
  faImage,
  faEllipsisV,
  faEnvelopeOpen,
  faRedo,
  faSlidersH,
  faTrashAlt,
  faTrashCan,
  faFileArchive,
  faFilePdf,
  faFileAlt,
  faEye,
  faCaretUp,
  faCodeBranch,
  faExclamationTriangle,
  faListUl,
  faTh,
  faGift,
  faUsers,
  faGlobeAmericas,
  faGlobe,
  faPlusSquare,
  faCaretDown,
  faUserPlus,
  faCircleNotch,
  faExclamation,
  faThumbsUp,
  faComments,
  faPalette,
  faEdit,
  faShare,
  faCheckSquare,
  faTools,
  faCheckDouble,
  faSmileBeam,
  faPoll,
  faPercentage,
  faTags,
  faIcons,
  faList,
  faUserFriends,
  faExclamationCircle,
  faFolderPlus,
  faTag,
  faAt,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDay,
  faMapMarkerAlt,
  faCross,
  faFlag,
  faThumbtack,
  faTable,
  faChartLine,
  faShapes,
  faMap,
  faFire,
  faLayerGroup,
  faRocket,
  faWrench,
  faSun,
  faMoon,
  faInfoCircle,
  faSpinner,
  faCapsules,
  faTasks,
  faCloudDownloadAlt,
  faSyncAlt,
  faBug,
  faProjectDiagram,
  faBolt,
  faPaperPlane,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faInfinity,
  faFile,
  faMusic,
  faMobile,
  faBookOpen,
  faTint,
  faPen,

  // Brand
  faFacebook,
  faFacebookF,
  faFacebookSquare,
  faGulp,
  faNodeJs,
  faSass,
  faTwitter,
  faGooglePlusG,
  faLinkedinIn,
  faMediumM,
  faHotjar,
  faYoutube,
  faVideo,
  faInfo,
  faPhone,
  faTrello,
  faCode,
  faJs,
  faHtml5,

  // Regular
  farHeart,
  farLightbulb,
  farObjectUngroup,
  farPaperPlane,
  farStar,
  farImage,
  farFileArchive,
  farFilePdf,
  farFile,
  farFileVideo,
  farFileAudio,
  farFileImage,
  farFileCode,
  farClock,
  farQuestionCircle,
  farDizzy,
  farLaughBeam,
  farSmileBeam,
  farCircle,
  farCopy,
  farComment,
  farEdit,
  faAngleDoubleUp,
  faNewspaper,
  faBuildingUser,
  faMapLocationDot,
  faBuilding,
  faBriefcase,
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  faRotateRight,
  faFlagReg,
  farMessage,
  farFloppyDisk
);
